import SubDebug from "Element/SubDebug";

export default function DebugPage() {
  return (
    <>
      <SubDebug />
    </>
  );
}
